import React, { useEffect, useState } from "react";
import { useForm, FormProvider } from "react-hook-form";
import { Link } from "react-router-dom";
import ActionMenuContainer from "../../ActionMenuContainer";
import Select from "../../../UI/Inputs/Select/Select";
import SelectItem from "../../../UI/Inputs/Select/SelectItem";
import Input from "../../../UI/Inputs/Input";
import Button from "../../../UI/Button";
import InputGroup from "../../../UI/Inputs/InputGroup";
import DatePickerInput from "../../../UI/Inputs/DatePickerInput";
import { updateEnrollmentRequest } from "../../../../requests/enrollments";
import { displayError } from "../../../../utils/displayError";
import { ToastNotification } from "../../../UI/ToastNotification";
import { getAllCourseDecisionsRequest } from "../../../../requests/courses";
import MultiSelect from "../../../UI/Inputs/MultiSelect";
import StudentSelect from "../StudentSelect";
import SeriesSelect from "../SeriesSelect";

export default function NewStudentVisit({ setRender, loaderStudent }) {
  const [decisionOptions, setDecisionOptions] = useState([]);
  const [student, setStudent] = useState(loaderStudent);
  const methods = useForm();
  const selectedSeries = methods.watch("series_id");
  const selectedEnrollmentId = methods.watch("selected_enrollment_id");

  const handleStudentChange = (student) => {
    setStudent(student);
  };

  const onSubmit = async (data) => {
    try {
      const decisions = data.decisions?.map((decision) => ({
        decision_option_id: decision.id,
        cached_enrollment_id: selectedEnrollmentId,
      }));

      const res = await updateEnrollmentRequest({
        visits_attributes: [
          {
            date: data.date,
            decisions_attributes: decisions,
            notes_attributes:
              data.note_text && data.note_type
                ? [
                    {
                      text: data.note_text,
                      type: data.note_type,
                    },
                  ]
                : [],
          },
        ],
        enrollmentId: selectedEnrollmentId,
      });

      if (res.data) {
        ToastNotification("success", "Visit created successfully.");
        setRender(null);
      }
    } catch (e) {
      displayError(e);
    }
  };

  const getAllCourseDecisions = async () => {
    const res = await getAllCourseDecisionsRequest({
      courseId: selectedSeries,
    });

    if (res.data) {
      setDecisionOptions(res.data);
    }
  };

  useEffect(() => {
    if (selectedSeries) {
      getAllCourseDecisions();
    }
  }, [selectedSeries]);

  return (
    <ActionMenuContainer
      label="Add a visit"
      handleGoingBack={() => setRender(null)}
    >
      <FormProvider {...methods}>
        <form
          onSubmit={methods.handleSubmit(onSubmit)}
          className="min-h-[380px]"
        >
          <StudentSelect
            onChange={handleStudentChange}
            loaderStudent={loaderStudent}
          />

          {student && !student.accepted && (
            <p className="text-orange-500 [&_a]:text-blue-500 [&_a]:underline">
              You need to accept the student before continuing.{" "}
              <Link to={`/students/${student.id}/overview`}>View Student</Link>
            </p>
          )}

          {student && student.accepted && (
            <>
              <InputGroup>
                <SeriesSelect student={student} methods={methods} />

                <DatePickerInput
                  id="date"
                  dark
                  label="Date"
                  selected={methods.watch("date") || new Date()}
                  isRequired
                />
              </InputGroup>
              {decisionOptions.length > 0 && (
                <InputGroup>
                  <MultiSelect
                    id="decisions"
                    label="Decisions"
                    placeholder="Add Decision"
                    options={decisionOptions}
                    defaultSelected={[]}
                    dark
                  />
                </InputGroup>
              )}
              <InputGroup>
                <Select
                  id="note_type"
                  classNames="w-full bg-transparent"
                  label="Note Type"
                  isRequired={Boolean(methods.watch("note_text"))}
                >
                  <SelectItem value="">Select</SelectItem>
                  <SelectItem value="Note">Note</SelectItem>
                  <SelectItem value="PrayerRequest">Prayer Request</SelectItem>
                </Select>
                <Input id="note_text" label="Note" dark />
              </InputGroup>
              <div className="text-center">
                <Button type="submit" variant="primary">
                  Save Visit
                </Button>
              </div>
            </>
          )}
        </form>
      </FormProvider>
    </ActionMenuContainer>
  );
}
